import React, { Component } from "react";
import "../../../src/styles/button_style.scss";

import GoogleMapsStreetView from "./GoogleMapsStreetView.js";
import UIOverlay from "./UIOverlay.js";
import WelcomeModal from "./WelcomeModal.js";
import ModalSubmitAnswer from "./ModalSubmitAnswer.js";
import ModalSubmitCountry from "./ModalSubmitCountry.js";

import ScoreBoard from "./ScoreBoard.js";
import ModalQuiz from "./ModalQuiz.js";
import WelcomeLevelTwo from "../LevelTwo/WelcomeLevelTwo.js";
import AlertWindow from "./AlertWindow.js";
import ScoreBoardLevelTwo from "../LevelTwo/ScoreBoardLevelTwo.js";
import EndScoreBoard from "../LevelTwo/EndScoreBoard.js";

export default class WelcomeScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalClose: false, // state to show UI elements when close MyModal
      answerOne: false, // state to open ModalSubmitAnswer again after close and know if answered
      continueCountry: false, // state to go from ModalSubmitAnswer to ModalSubmitCountry
      answerTwo: false, // state to open ModalSubmitCountry again after close and know if answered
      continueScoreBoard: false, // state to go from ModalSubmitCountry to ScoreBoard at level one
      continueQuizOne: false, // state to go from WelcomeLevelTwo to ModalQuiz
      continueScoreBoardTwo: false,
      endgame: false
    };
  }

  // when the modal is closed the UI elements should show
  showUI = () => {
    this.setState({ modalClose: true });
  };

  itisending = () => {
    this.setState({ endgame: true });
  };

  // readyToAnswer changes state of answerOne which shows map where the user can guess where they are!
  readyToAnswer = () => {
    this.setState({
      answerOne: true,
      answerTwo: false,

      //rest states to next round
      continueCountry: false,
      continueScoreBoard: false,
      continueQuizOne: false,
      continueScoreBoardTwo: false,
      continueNextRound: false //state from app.js
    });
  };

  // readyToAnswerAgain is called when you close ModalSubmitAnswer so you can open the modal again
  readyToAnswerAgain = () => {
    this.setState({ answerOne: false });
  };

  // goToCountry is called when you press contiune button on ModalSubmitAnswer
  goToCountry = () => {
    this.setState({
      continueCountry: true
    });
  };

  // readyToAnswerCountry is called from IUOverlays when ModalSubmitCountry shows
  readyToAnswerCountry = () => {
    this.setState({ answerTwo: true });
  };

  // readyToAnswerAgainCountry is called when you close ModalSubmitCountry so you can open the modal again
  readyToAnswerAgainCountry = () => {
    this.setState({ answerTwo: false });
  };

  // goToScoreBoardLvlOne is called when you press continue button at ModalSubmitCountry then ScoreBoard shows
  goToScoreBoardLvlOne = () => {
    this.setState({ continueScoreBoard: true });
  };

  // goToLvlTwoQuizOne is called from WelcomeLevelTwo to open ModalQuiz
  goToLvlTwoQuizOne = () => {
    this.setState({ continueQuizOne: true });
    localStorage.setItem("continueQuizOne", "true");
  };

  // goToScoreBoardLvlOne is called when you press continue button at ModalSubmitCountry then ScoreBoard shows
  goToScoreBoardLvlTwo = () => {
    this.setState({ continueScoreBoardTwo: true });
  };

  componentDidMount() {
    window.addEventListener("focus", this.onFocus);

    if (!localStorage.hasOwnProperty("questionsFromAPI")) {
      this.fetchAPI(1);
      if (localStorage.getItem("questionsFromAPI") === "[]") {
        this.fetchAPI(5);
      }
    }
    if (localStorage.getItem("continueScoreBoard") === "true") {
      this.goToScoreBoardLvlOne();
    }
  }

  componentWilUnmount() {
    window.removeEventListener("focus", this.onFocus);
  }

  onFocus = () => {
    if (this.state.modalClose) {
      this.setState({ cheat: true });
    }
  };

  afterFocus = () => {
    this.setState({ cheat: false });
  };

  //Algorithm that goes through all words in the array which is a fetch from
  //the API Open Trivia. Returns all questions with the word in it - somewhere
  //in the object
  findRelevantQuestions = (array, word) => {
    let matches = [],
      i,
      key;

    for (i = array.length; i--; ) {
      for (key in array[i]) {
        if (array[i].hasOwnProperty(key) && array[i][key].indexOf(word) > -1) {
          matches.push(array[i]);
        }
      }
    }
    return matches;
  };

  fetchAPI = x => {
    let keyWord;
    let res;
    let resn;
    let array = [];
    let openTriviaURL;

    if (x === 5) {
      openTriviaURL =
        "https://opentdb.com/api.php?amount=50&category=22&difficulty=easy&type=multiple";
    } else if (localStorage.hasOwnProperty("whichRound")) {
      if (parseInt(localStorage.getItem("whichRound"), 10) === 1) {
        openTriviaURL =
          "https://opentdb.com/api.php?amount=50&category=22&difficulty=easy&type=multiple";
      } else if (parseInt(localStorage.getItem("whichRound"), 10) === 2) {
        openTriviaURL =
          "https://opentdb.com/api.php?amount=50&category=22&difficulty=medium&type=multiple";
      } else {
        openTriviaURL =
          "https://opentdb.com/api.php?amount=43&category=22&difficulty=hard&type=multiple";
      }
    }

    fetch(openTriviaURL)
      .then(response => {
        res = this.findRelevantQuestions(
          response.json,
          this.props.currentCoordinates.country
        );
        resn = this.findRelevantQuestions(
          response.json,
          this.props.currentCoordinates.continent
        );

        if (!res.length === 0) {
          keyWord = this.props.currentCoordinates.country;
          return response.json();
        } else if (!resn.length === 0) {
          keyWord = this.props.currentCoordinates.continent;
          return response.json();
        } else {
          keyWord = "multiple";
          return response.json();
        }
      })
      .then(myJson => {
        let a = this.findRelevantQuestions(myJson.results, keyWord);
        array = array.concat(a);
      });
    fetch(openTriviaURL)
      .then(response => {
        res = this.findRelevantQuestions(
          response.json,
          this.props.currentCoordinates.country
        );
        resn = this.findRelevantQuestions(
          response.json,
          this.props.currentCoordinates.continent
        );

        if (!res.length === 0) {
          keyWord = this.props.currentCoordinates.country;
          return response.json();
        } else if (!resn.length === 0) {
          keyWord = this.props.currentCoordinates.continent;
          return response.json();
        } else {
          keyWord = "easy";
          return response.json();
        }
      })
      .then(myJson => {
        let a = this.findRelevantQuestions(myJson.results, keyWord);
        array = array.concat(a);
      });
    fetch(openTriviaURL)
      .then(response => {
        res = this.findRelevantQuestions(
          response.json,
          this.props.currentCoordinates.country
        );
        resn = this.findRelevantQuestions(
          response.json,
          this.props.currentCoordinates.continent
        );

        if (!res.length === 0) {
          keyWord = this.props.currentCoordinates.country;
          return response.json();
        } else if (!resn.length === 0) {
          keyWord = this.props.currentCoordinates.continent;
          return response.json();
        } else {
          keyWord = "easy";
          return response.json();
        }
      })
      .then(myJson => {
        let a = this.findRelevantQuestions(myJson.results, keyWord);
        array = array.concat(a);

        localStorage.setItem("questionsFromAPI", JSON.stringify(array));
        // this.setState({
        //   questions: array
        //  });
      });
  };

  render() {
    return (
      <div>
        {/*} This fuction shows a modal when user leaves the website to cheat!*/}
        {this.state.cheat && <AlertWindow afterFocus={this.afterFocus} />}{" "}
        {/*// move to where it should appear */}
        {this.props.whichRound === 1 ? (
          <WelcomeModal
            username={this.props.username}
            showUI={this.showUI}
            readyToAnswerAgain={this.readyToAnswerAgain}
            readyToAnswerCountry={this.readyToAnswerCountry}
            readyToAnswerAgainCountry={this.readyToAnswerAgainCountry}
            goToCountry={this.goToCountry}
            whichModal={this.props.whichModal}
            level={this.props.level}
            changeModal={this.props.changeModal}
            avatar={localStorage.getItem("avatar")}
          />
        ) : this.state.modalClose === false ? (
          this.showUI()
        ) : (
          console.log("Else condition from LevelOne #1. Reloaded the page")
        )}
        {/* When ModalSubmitAnswer is closed and you want to open it again, answerOne is
          whichModal={this.state.whichModal}
        />
        {/* When MyModal is closed the UI elements should show */}
        {this.state.modalClose && (
          <UIOverlay
            totalScore={this.props.totalScore}
            readyToAnswer={this.readyToAnswer}
            readyToAnswerAgain={this.readyToAnswerAgain}
            readyToAnswerCountry={this.readyToAnswerCountry}
            readyToAnswerAgainCountry={this.readyToAnswerAgainCountry}
            goToCountry={this.goToCountry}
            whichModal={this.props.whichModal}
            level={this.props.level}
            changeModal={this.props.changeModal}
            whichRound={this.props.whichRound}
            continueQuizModal={this.props.continueQuizModal}
            continueWelcomeLevelTwo={this.props.continueWelcomeLevelTwo}
            continueScoreBoard={this.state.continueScoreBoard}
            avatar={localStorage.getItem("avatar")}
            goRestart={this.props.goRestart}
            goToEndScreen={this.props.goToEndScreen}
          />
        )}
        {/* When ModalSubmitAnswer is closed and you want to open it again, answerOne is
          true when ModalSubmitAnswer is closed and can be opend again */}
        {this.state.answerOne && (
          <ModalSubmitAnswer
            compare={this.props.compare}
            totalScore={this.props.totalScore}
            readyToAnswerAgain={this.readyToAnswerAgain}
            readyToAnswerCountry={this.readyToAnswerCountry}
            readyToAnswerAgainCountry={this.readyToAnswerAgainCountry}
            goToCountry={this.goToCountry}
            whichModal={this.props.whichModal}
            currentCoordinates={this.props.currentCoordinates}
            changeModal={this.props.changeModal}
          />
        )}
        {/* When press continue on ModalSubmitAnswer the state continueCountry is true and 
          next modal ModalSubmitCountry shows */}
        {this.state.continueCountry && (
          <ModalSubmitCountry
            compare={this.props.compare}
            compareCountry={this.props.compareCountry}
            totalScore={this.props.totalScore}
            readyToAnswerCountry={this.readyToAnswerCountry}
            readyToAnswerAgainCountry={this.readyToAnswerAgainCountry}
            currentCoordinates={this.props.currentCoordinates}
            goToCountry={this.goToCountry}
            whichModal={this.props.whichModal}
            goToScoreBoardLvlOne={this.goToScoreBoardLvlOne}
            changeModal={this.props.changeModal}
            readyToAnswerAgain={this.readyToAnswerAgain}
            distanceCountry={this.props.distanceCountry}
          />
        )}
        {/* When you close ModalSubmitCountry without select country and press "I am ready to answer" 
          this ModalSubmitCountry shows again */}
        {this.state.answerTwo && (
          <ModalSubmitCountry
            compare={this.props.compare}
            compareCountry={this.props.compareCountry}
            totalScore={this.props.totalScore}
            readyToAnswerCountry={this.readyToAnswerCountry}
            readyToAnswerAgainCountry={this.readyToAnswerAgainCountry}
            currentCoordinates={this.props.currentCoordinates}
            goToCountry={this.goToCountry}
            whichModal={this.props.whichModal}
            goToScoreBoardLvlOne={this.goToScoreBoardLvlOne}
            changeModal={this.props.changeModal}
            readyToAnswerAgain={this.readyToAnswerAgain}
          />
        )}
        {/* When continue button at ModalSubmitCountry is pressed the state continueScoreBoard is true 
          and ScoreBoard shows */}
        {this.state.continueScoreBoard && (
          <ScoreBoard
            username={this.props.username}
            totalScore={this.props.totalScore}
            goToWelcomeLevelTwo={this.props.goToWelcomeLevelTwo}
            goToEndScreen={this.props.goToEndScreen}
            avatar={localStorage.getItem("avatar")}
          />
        )}
        {/* When Next Level button at Scoreboard Level One is pressed WelcomeLevelTwo shows */}
        {this.props.continueWelcomeLevelTwo && (
          <WelcomeLevelTwo
            goToWelcomeLevelTwo={this.props.goToWelcomeLevelTwo}
            goToLvlTwoQuizOne={this.goToLvlTwoQuizOne}
            whichRound={this.props.whichRound}
            avatar={localStorage.getItem("avatar")}
          />
        )}
        {this.state.continueQuizOne && (
          <ModalQuiz
            totalScore={this.props.totalScore}
            level={this.props.level}
            currentCoordinates={this.props.currentCoordinates}
            goToScoreBoardLvlTwo={this.goToScoreBoardLvlTwo}
            countRounds={this.props.countRounds}
            whichRound={this.props.whichRound}
            itisending={this.itisending}
            updateScore={this.props.updateScore}
            fetchAPI={this.fetchAPI}
          />
        )}
        {this.props.continueQuizModal && (
          <ModalQuiz
            totalScore={this.props.totalScore}
            level={this.props.level}
            currentCoordinates={this.props.currentCoordinates}
            goToScoreBoardLvlTwo={this.goToScoreBoardLvlTwo}
            countRounds={this.props.countRounds}
            whichRound={this.props.whichRound}
            itisending={this.itisending}
            updateScore={this.props.updateScore}
            fetchAPI={this.fetchAPI}
          />
        )}
        {this.state.endgame === true ? (
          <div>
            <EndScoreBoard
              username={this.props.username}
              totalScore={this.props.totalScore}
              goToEndScreen={this.props.goToEndScreen}
              avatar={localStorage.getItem("avatar")}
            />
          </div>
        ) : this.state.continueScoreBoardTwo === true ? (
          <div>
            <ScoreBoardLevelTwo
              username={this.props.username}
              totalScore={this.props.totalScore}
              goToNextRound={this.props.goToNextRound}
              goToEndScreen={this.props.goToEndScreen}
              goToScoreBoardLvlTwo={this.goToScoreBoardLvlTwo}
              countRounds={this.props.countRounds}
              whichRound={this.props.whichRound}
              avatar={localStorage.getItem("avatar")}
            />
          </div>
        ) : (
          console.log("Else condition from LevelOne #2. Reloaded the page")
        )}
        {/* Always renders to the screen */}
        <GoogleMapsStreetView
          currentCoordinates={this.props.currentCoordinates}
          username={this.props.username}
          whichRound={this.props.whichRound}
        />
      </div>
    );
  }
}
